/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_VIDEO_CONTENT_CATEGORIES_PANEL',
  PUT: 'UPDATE_VIDEO_CONTENT_CATEGORIES_PANEL',
  DELETE: 'DELETE_VIDEO_CONTENT_CATEGORIES_PANEL',
  RESET: 'RESET_VIDEO_CONTENT_CATEGORIES_PANEL',
};

export const getDraftId = () => (`videoContentCategoriesPanel-draft${new Date().valueOf()}`);

export const videoContentCategoriesPanelReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      const id = action.payload.id ? action.payload.id : getDraftId();
      return [
        ...state,
        { ...action.payload, id },
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
